import Button from '@components/Button';
import Column from '@components/Column';
import styled from '@emotion/styled';
import { useFlow } from '@router/stackflow';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { Permission, requestPermission } from '@utils/nativeUtils';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import PermissionHeader from './components/PermissionHeader';
import PermissionList from './components/PermissionList';

const PermissionBottomSheet: ActivityComponentType = () => {
    const { pop } = useFlow();
    const { t } = useTranslation('permission');

    const handleRequestPermission = () => {
        requestPermission(Permission.NOTIFICATION);
        pop();
    };

    useEffect(() => {
        window.localStorage.setItem('permissionAsked', 'true');
    }, []);
    return (
        <BottomSheet>
            <Container>
                <Column fullWidth align='center'>
                    <PermissionHeader/>
                    <PermissionList/>
                    <Footer>
                        <Button fullWidth
                            onClick={handleRequestPermission} >
                            {t('confirm')}
                        </Button>
                    </Footer>
                </Column>
            </Container>
        </BottomSheet>
    );
};

const Container = styled.div`
    padding: 0 20px;
    position: relative;
    height: 100%;
`;

const Footer = styled.footer`
    width: 100%;
    position: absolute;
    padding: 0 20px calc(20px + env(safe-area-inset-bottom));
    bottom: 0;
`;

export default PermissionBottomSheet;
